import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import BoxEditor from "./BoxEditor";
import PaymentList from "./lists/paymentList";
import PaymentForm from "./forms/paymentForm";
import isEqual from 'lodash-es/isEqual';
import Button from "../form/Button";
import {postData} from "../../utils/request";

class paymentEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    deleteForm = async (event) => {
        await this.props.deleteForm(event);
        this.list && this.list.refresh();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    checkPaymentStatus = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.values.serviceprovider_type + '.checkPaymentStatus',
                id: this.props.values.serviceprovider_id
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    sendNotificationEmail = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.sendNotificationEmail',
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield]
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    render() {

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const props = {...this.props};

        const editorButtons = [];
        if ((this.props.values.serviceprovider_type === "Kh" || this.props.values.serviceprovider_type === "SimplePay") && this.props.values[this.props.componentConfig.idfield]) {
            if (parseInt(this.props.values.immutable + "") > 0) {
                editorButtons.push(
                    <Button
                        disabled={this.props.isLoading}
                        color="default"
                        className="pull-right"
                        onClick={this.checkPaymentStatus}
                    >
                        Állapot lekérdezés
                    </Button>
                );
            }
            editorButtons.push(
                <Button
                    disabled={this.props.isLoading}
                    color="default"
                    className="pull-right"
                    onClick={this.sendNotificationEmail}
                >
                    Email küldése
                </Button>
            );
        }

        const actionButtons = [];

        if (props.businessComponent) {
            props.filter = [
                {
                    field: "component_type",
                    value: props.businessComponent.componentConfig.componentname
                },{
                    field: "component_id",
                    value: props.businessComponent.values[props.businessComponent.componentConfig.idfield]
                }
            ];
            if (!this.props.disable) {
                actionButtons.push(
                    <Button
                        key="0"
                        disabled={props.isLoading}
                        color="default"
                        onClick={this.pristineForm}
                    >
                        Új
                    </Button>
                );
                editorButtons.push(
                    <Button
                        disabled={(this.props.values[this.props.componentConfig.idfield] && parseInt(this.props.values.immutable || "0") !== 0) || !props.dirty || props.isLoading}
                        color="primary"
                        className="pull-right"
                        onClick={this.saveForm}
                    >
                        Mentés
                    </Button>
                );
                if (parseInt(this.props.values.immutable || "0") === 0) {
                    editorButtons.push(
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.deleteForm}
                        >
                            Törlés
                        </Button>
                    );
                }
            }
        }

        const disabled = this.props.isLoading || this.props.disable || parseInt(this.props.values.immutable || "0") > 0;

        return (
            <Fragment>
                <List
                    {...props}
                    collapsed={props.collapsed || false}
                    theme="default"
                    header={"Fizetések"}
                    footer={actionButtons}
                >
                    <PaymentList
                        ref={(el) => this.list = el}
                        {...props}
                        loadForm={this.loadForm}
                    />
                </List>
                <Editor
                    {...props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={((props.values.prefix || "") + (props.values.billnum || "")) + " Fizetés"}
                    footer={<Fragment>
                        {Array.isArray(editorButtons) ? editorButtons.map((i) => i) : editorButtons}
                    </Fragment>}
                >
                    <PaymentForm
                        {...props}
                         disabled={disabled}
                    />
                </Editor>
            </Fragment>
        );
    }
}
export default createEditor({componentName: "payment", WrappedComponent: paymentEditor, props: {view: "admin"}});

